module.exports = __webpack_public_path__ + "static/media/iconTalk.b32f7390.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconTalk.svg
// module id = 209
// module chunks = 0